import {
  ICategory,
  IProduct,
} from 'featureSliced/shared/store/reducers/CategoriesReducer/types'
import { IBucketProduct } from 'featureSliced/shared/store/reducers/QRMenuBucketReducer/types'

const productKey = (categoryId: number, productId: number): string =>
  `${categoryId}|${productId}`

// Every (categoryId, productId) the server currently serves — top-level products and,
// recursively, sub-template entries. The server already drops a template's whole
// subtree when it is closed for the day (QRM-648, both for the top-level category and
// for a sub-template inside it), so a missing pair means "not orderable today" without
// the client needing its own copy of the weekday rule.
export const buildAvailableProductKeys = (
  topLevelProducts: IProduct[] = []
): Set<string> => {
  const keys = new Set<string>()
  const walk = (products: IProduct[] = []) => {
    products.forEach((product) => {
      keys.add(productKey(product.categoryId, product.id))
      if (product.innerCategoryItems?.length) walk(product.innerCategoryItems)
    })
  }
  walk(topLevelProducts)
  return keys
}

export const flattenTopLevelProducts = (
  categories: ICategory[] = []
): IProduct[] => categories.flatMap((category) => category.products)

// Bucket lines whose (categoryId, productId) is no longer in the currently loaded
// menu — the template they came from is closed for the (pickup) day, or a
// sub-template inside it is. An empty product list means the menu has not loaded
// yet, so nothing is removed (mirrors the sold-out/lead-days checkpoints' own guard).
export const findTemplateUnavailableLines = (
  bucketProducts: IBucketProduct[] = [],
  topLevelProducts: IProduct[] = []
): IBucketProduct[] => {
  if (!topLevelProducts.length) return []
  const availableKeys = buildAvailableProductKeys(topLevelProducts)
  return bucketProducts.filter(
    (line) => !availableKeys.has(productKey(line.categoryId, line.productId))
  )
}
